import { BasicFrame } from 'components/organisms';
import { ButtonActor, Card, Heading, Spacer } from 'components';
import { frameConfigBasic } from '../../../AppConfig';
import { getScreenTranslation } from '../../../utils/translations';
import { useCustomNavigation } from 'hooks/useCustomNavigation';
import { useTranslation } from 'react-i18next';
import { WarningGreyIcon } from 'components/icons';
import classNames from 'classnames';
import layout from 'scss/layout.module.scss';
import styles from 'pages/OnlineBank/OnlineBankError/OnlineBankError.module.scss';
import Title from 'components/atoms/Title/Title';

export default function OnlineBankError() {
  const { navigateToOnlineBankVerification } = useCustomNavigation();
  const i18Next = useTranslation();

  const { title, cardText, buttonText } = getScreenTranslation(
    'online_bank_identification_errorCode',
    i18Next,
  );

  return (
    <BasicFrame
      {...frameConfigBasic}
      hideLogout
      contentLayoutClassName={layout['frame-x-compact']}
      contentWrapperClassName={layout['width-md']}
    >
      <Spacer marginTop={{ default: 'unset', s: '10px' }}>
        <Title
          text={title}
          icon={<WarningGreyIcon />}
          forceColumn
          iconClassName={styles['title-icon']}
        />
      </Spacer>
      <Spacer
        marginTop={{ default: '55px', m: '30px' }}
        marginBottom={{ default: '60px', m: '50px' }}
      >
        <Card className={styles['outer-card']}>
          <Spacer
            paddingHorizontal={{ default: '30px', xs: '20px' }}
            paddingVertical={{ default: '25px', m: '21px' }}
          >
            <Card className={styles['inner-card']}>
              <Spacer
                paddingHorizontal={{ default: '50px', m: '25px' }}
                paddingVertical={{ default: '6px' }}
              >
                <Heading
                  dataTest="header"
                  text={cardText}
                  level="h3"
                  className={styles['card-text']}
                  weight="medium"
                />
              </Spacer>
            </Card>
          </Spacer>
        </Card>
      </Spacer>
      <ButtonActor
        buttonProps={{
          dataTest: 'errorCode-btn',
          onClick: navigateToOnlineBankVerification,
          fill: true,
        }}
        className={classNames(layout['width-sm'], layout['frame-x-padding'])}
      >
        {buttonText}
      </ButtonActor>
    </BasicFrame>
  );
}
